module.exports = require("./ha-Arab");